import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt } from "react-icons/fa";

const contacts = [
    {
        id: 1,
        icon: <FaMapMarkedAlt />,
        title: "address",
        content: ["Sparkle Laundry Services, 789 Elm Street"],
    },
    {
        id: 2,
        icon: <FaPhoneAlt />,
        title: "call us",
        content: ["+111-222-333", "+123-456-7890"],
    },
    {
        id: 3,
        icon: <FaEnvelope />,
        title: "mail us",
        content: ["info@example.com", "xyz@gmail.com"],
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "opening hours",
        content: ["Mon - Fri: 7 AM - 7 PM", "Sat - Sun: 8 AM - 6 PM"],
    },
];

export default contacts;